<template>
  <va-accordion v-model="accordionValue" class="sidebar-accordion va-sidebar__menu__inner" multiple>
    <template v-for="(route, idx) in items">
      <va-collapse v-if="route.meta.roles[0] === '*' || route.meta.roles.includes(userRole)" :key="idx" class="p-0">
        <template #header>
          <va-sidebar-item :active="isRouteActive(route)" :to="route.children ? undefined : { name: route.name }">
            <va-sidebar-item-content>
              <va-icon :name="route.meta.icon" class="va-sidebar-item__icon text-white" />
              <va-sidebar-item-title class="text-white">
                {{ t(route.displayName) }}
              </va-sidebar-item-title>
              <span
                v-if="shouldShowApplicationsBadge(route)"
                class="ml-2 rounded-full px-2 py-0.5 text-xs font-semibold text-black"
                style="background-color: #f9ad22"
              >
                {{ pendingApplicationsCount }}
              </span>

              <va-icon
                v-if="route.children"
                :name="accordionValue[idx] ? 'expand_less' : 'expand_more'"
                class="text-white"
              />
            </va-sidebar-item-content>
          </va-sidebar-item>
        </template>
        <template v-for="(child, index) in route.children" :key="index">
          <va-sidebar-item :active="isRouteActive(child)" :to="{ name: child.name, query: child.query }">
            <va-sidebar-item-content>
              <div class="va-sidebar-item__icon text-white" />

              <va-sidebar-item-title class="uppercase text-white">
                {{ t(child.displayName) }}
              </va-sidebar-item-title>
            </va-sidebar-item-content>
          </va-sidebar-item>
        </template>
      </va-collapse>
    </template>
  </va-accordion>
</template>

<script setup lang="ts">
  import { onMounted, ref } from 'vue'
  import { INavigationRoute } from '../NavigationRoutes'
  import { useRoute } from 'vue-router'
  import { useI18n } from 'vue-i18n'
  import { useGlobalStore } from '@/stores/global-store'
  import { storeToRefs } from 'pinia'
  const { t } = useI18n()

  const props = withDefaults(
    defineProps<{
      items?: INavigationRoute[]
      pendingApplicationsCount?: number
    }>(),
    {
      items: () => [],
      pendingApplicationsCount: 0,
    },
  )

  const accordionValue = ref<boolean[]>([])

  onMounted(() => {
    accordionValue.value = props.items.map((item) => isItemExpanded(item))
  })

  function isRouteActive(item: INavigationRoute) {
    const route = useRoute()
    if (item.name !== route.name) return false
    if (!item.query) return true
    return JSON.stringify(item.query) === JSON.stringify(route.query)
  }

  function isItemExpanded(item: INavigationRoute): boolean {
    if (!item.children) {
      return false
    }

    const isCurrentItemActive = isRouteActive(item)
    const isChildActive = !!item.children.find((child) =>
      child.children ? isItemExpanded(child) : isRouteActive(child),
    )

    return isCurrentItemActive || isChildActive
  }

  const globalStore = useGlobalStore()
  const { userRole } = storeToRefs(globalStore)

  const shouldShowApplicationsBadge = (route: INavigationRoute) => {
    return (
      userRole.value === 'business_partner' && route.name === 'drivers' && (props.pendingApplicationsCount || 0) > 0
    )
  }
</script>
